<!--
Copyright (c) 2022-2023 Antmicro <www.antmicro.com>

SPDX-License-Identifier: Apache-2.0
-->

<!-- eslint-disable max-len -->
<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.839382 9.84241L0 14L4.15783 13.1617L14 3.3193L10.681 0L0.839382 9.84241ZM3.5821 12.0872L1.49269 12.5095L1.91325 10.4188L3.5821 12.0872ZM12.3498 3.31814L4.4069 11.2623L2.73864 9.59332L9.05296 3.27789L10.7131 4.93812L11.5379 4.11325L9.87776 2.45302L10.681 1.64974L12.3498 3.31814Z"
            fill="#E5E5E5"
        />
    </svg>
</template>
